export const ORDER_BY = {
  patientName: "patient",
  clinicName: "clinic",
  membershipName: "membership",
  membershipSavings: "membership_benefit",
};
